// Component: Input.jsx
// Purpose: DS text input — a thin wrapper over the `.ds-input` classes. Optional
//   field wrapper (label/hint/error) and affix (prefix/suffix), size sm/md/lg,
//   ref-forwarded. Styling lives in ds-components.css (preview/form-inputs.html).

import React, { forwardRef, useId } from "react";
import { cx } from "./cx";

const SIZES = { sm: "sm", md: "", lg: "lg" };

export const Input = forwardRef(function Input(
  { label, hint, error, size = "md", prefix, suffix, id, className, invalid, ...props },
  ref
) {
  const reactId = useId();
  const inputId = id || reactId;
  const isInvalid = invalid || Boolean(error);

  const inputEl = (
    <input
      ref={ref}
      id={inputId}
      className={cx("ds-input", SIZES[size], className)}
      aria-invalid={isInvalid || undefined}
      {...props}
    />
  );

  //! Affix wraps the input with a currency/unit pre/post cell (border on wrapper).
  const control =
    prefix != null || suffix != null ? (
      <div className="ds-affix">
        {prefix != null && <span className="ds-affix-pre">{prefix}</span>}
        {inputEl}
        {suffix != null && <span className="ds-affix-post">{suffix}</span>}
      </div>
    ) : (
      inputEl
    );

  //--> No field chrome requested → return the bare control.
  if (label == null && hint == null && error == null) return control;

  return (
    <div className="ds-field">
      {label != null && <label htmlFor={inputId}>{label}</label>}
      {control}
      {error != null ? (
        <div className="ds-field-err">{error}</div>
      ) : hint != null ? (
        <div className="ds-field-hint">{hint}</div>
      ) : null}
    </div>
  );
});

export default Input;
